export default __webpack_public_path__ + "static/media/icons-share.dec09f53.svg";